<template>
  <div v-if="noLink" class="tag-item">
    <div :class="theme" class="tag-label" />
    <span>
      {{ title }}
    </span>
  </div>
  <NuxtLink
    v-else
    :aria-label="'See more in ' + title"
    :class="theme"
    :to="link"
    class="button button--tag rounded-sm"
  >
    <span>
      {{ title }}
    </span>
  </NuxtLink>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    title: string
    theme: string
    link: string
    noLink?: boolean
  }>(),
  {
    noLink: false,
  },
)
</script>

<style lang="less" scoped>
.tag-item {
  .flex();
  .align-center();

  span {
    .font-sm();

    color: @color-fill-text-alt;
  }

  .tag-label {
    .rounded();

    width: @9px;
    height: @9px;
    margin-right: @gutter-xs;
  }
}
</style>
